export const MODALIDAD_MODELO_180 = {
  DINERARIA: 1,
  ESPECIE: 2,
} as const

export type ModalidadModelo180Type =
  (typeof MODALIDAD_MODELO_180)[keyof typeof MODALIDAD_MODELO_180]
